<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e2064560" style="color: #82a339"><b>VICHYSSOISE</b></p>
<p class="ext" id="d7e2065060"><b><i>This elegant soup, traditionally served cold, is just as delicious hot (just call it cream of potato and leek soup). Either way, serve it in small cups, and be sure to garnish with a sprinkling of snipped fresh chives.</i></b></p>
<p class="h4" id="d7e2066660" style="color: #496210"><b>Prep: 20 minutes plus chilling Cook: 55 minutes</b></p>
<p class="ul" id="d7e2067160">4 medium leeks (1¼ pounds)</p>
<p class="ul" id="d7e2068260">2 tablespoons butter or margarine</p>
<p class="ul" id="d7e2068560">1 pound all-purpose potatoes (3 medium), peeled <br/> and thinly sliced</p>
<p class="ul" id="d7e2069260">2 cans (14½ ounces each) chicken broth or 3½ cups <br/> Chicken Broth</p>
<p class="ul" id="d7e2071560">½ cup water</p>
<p class="ul" id="d7e2072460">1 teaspoon salt</p>
<p class="ul" id="d7e2072760">¼ teaspoon ground black pepper</p>
<p class="ul" id="d7e2073760">1 cup milk</p>
<p class="ul" id="d7e2074060">½ cup heavy or whipping cream</p>
<p class="pub" id="d7e2075160" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> Cut off roots and trim dark green tops from leeks; cut each leek lengthwise in half. Cut enough of white and pale green parts crosswise into ¼-inch pieces to equal 4½ cups. (Reserve any leftover leeks for another use.) Rinse leeks in large bowl of cold water, swishing to remove sand; transfer to colander to drain, leaving sand in bottom of bowl.</p>
<p class="pub" id="d7e2079460"><span style="color: #c15b49"><b>2.</b></span> In 4-quart saucepan, melt butter over medium heat; add leeks and cook, stirring occasionally, 8 to 10 minutes. Add potatoes, broth, water, salt, and pepper; heat to boiling over high heat. Reduce heat; cover and simmer 30 minutes.</p>
<p class="pub" id="d7e2081460"><span style="color: #c15b49"><b>3.</b></span> Spoon half of mixture into blender; cover, with center part of cover removed to let steam escape, and puree until smooth. Pour into bowl. Repeat with remaining mixture.</p>
<p class="pub" id="d7e2083360"><span style="color: #c15b49"><b>4.</b></span> Stir milk and cream into puree. To serve hot, return soup to same clean saucepan and heat through over low heat (do not boil). To serve cold, cover and refrigerate at least 4 hours or until very cold. Makes about 8 cups or 8 first-course servings.</p>
<p class="ntx" id="d7e2086060">Each serving: About 161 calories, 4g protein, 14g carbohydrate, 10g total fat (6g saturated), 32mg cholesterol, 778mg sodium.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c58_r1.vue?277ddecc